import clsx from 'clsx';
import styles from './ToleranceLegend.module.scss';

/** Colour key for the reconciliation tolerance bands painted on compared cells. */
function ToleranceLegend({ className, bothDirections }: { className?: string; bothDirections?: boolean }) {
    const sign = bothDirections ? '±' : '';
    return (
        <div className={clsx(styles.Legend, className)}>
            <span className={styles.LegendItem}>
                <span className={clsx(styles.LegendSwatch, styles.SwatchGreen)} /> Δ&lt;{sign}10%
            </span>
            <span className={styles.LegendItem}>
                <span className={clsx(styles.LegendSwatch, styles.SwatchYellow)} /> Δ&lt;{sign}20%
            </span>
            <span className={styles.LegendItem}>
                <span className={clsx(styles.LegendSwatch, styles.SwatchRed)} /> Δ{sign}20%+
            </span>
            <span className={styles.LegendItem}>
                <span className={clsx(styles.LegendSwatch, styles.SwatchNotAvailable)} /> Benchmark
            </span>
        </div>
    );
}

export default ToleranceLegend;
